import * as React from 'react';

function SvgHotelDashboard(props) {
    return (
        <svg
            version="1.1"
            id="Layer_1"
            height="16"
            width="16"
            xmlns="http://www.w3.org/2000/svg"
            //  xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 413.9 413.9"
            style={{ enableBackground: "new 0 0 413.9 413.9" }}
            {...props}
        //    xml:space="preserve"
        >
            {/* <style type="text/css">
	.st0{stroke:#000000;stroke-width:2;stroke-miterlimit:10;}
	.st1{fill:#FFFFFF;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}
</style> */}
            <path className="st0" d="M17.9,198.9c0-1.2,0-2.4,0-3.7c1.5-2,2.7-4.3,4.5-6.1c8-8.2,16.1-16.3,24.3-24.3c1.8-1.7,2.6-3.5,2.6-6.1
	c-0.1-17-0.2-34.1,0.1-51.1c0.1-4.1,0.7-8.6,2.4-12.3c4.5-9.7,12.9-13.3,23.2-13.3c58.9,0,117.8,0,176.7,0.1c2.5,0,4.3-0.7,6.1-2.5
	c15.9-16.1,32.1-32,47.9-48.1c5.3-5.4,10.8-10.1,18.4-11.7c1.9,0,3.9,0,5.8,0c0.3,0.2,0.6,0.4,0.9,0.5c13.4,3.6,21.2,13.8,28.3,24.7
	c0.3,0.4,0.4,0.9,0.5,1.4c2.9,9.9,0.1,18.2-7.2,25.1c-3.4,3.2-6.9,6.3-10.3,9.5c0.3,0.4,0.5,0.7,0.8,1.1c5.4,0,10.9,0,16.3,0
	c9.8,0.1,18.3,3.3,25,10.7c4.4,4.9,6.4,10.8,7.8,17c0,80.4,0,160.7,0,241.1c-0.2,0.4-0.5,0.8-0.6,1.3c-2.7,14.7-13.7,24.8-28.4,25.8
	c-7.9,0.5-15.8,0.3-23.7,0.3c-6.9,0-9.6-2.8-9.6-9.9c0-9.2,0-18.5,0-27.7c0-2.9,0-5.8,0-8.7c-23,0-45.6,0-68.6,0
	c0.7,0.8,1,1.2,1.3,1.5c6.6,6.9,6.6,9.6-0.2,16.4c-13.2,13.2-26.3,26.4-39.5,39.4c-1.9,1.9-4.5,3.2-6.8,4.7c-0.7,0-1.5,0-2.2,0
	c-2.2-1.6-4.7-3-6.6-4.9c-18.4-18.3-36.7-36.6-55-55c-1.9-1.9-3.7-2.7-6.4-2.7c-23.4,0.1-46.7,0.1-70.1,0c-3,0-6.1-0.1-9-0.9
	c-11.2-3-17.5-11.7-17.5-24.2c-0.1-23.7-0.1-47.4,0-71.2c0-2.7-0.7-4.8-2.7-6.7c-7.8-7.5-15.4-15.2-23-22.9
	C21.5,203.5,19.8,201.1,17.9,198.9z M376.3,320.1c0.1-1.3,0.2-2.1,0.2-3c0-67.3,0-134.7,0-202c0-11.1-6.3-17.3-17.5-17.4
	c-9.6-0.1-19.2,0.1-28.9-0.1c-2.8,0-4.7,0.9-6.7,2.8c-30.1,30.2-60.3,60.4-90.6,90.7c21.8,0,43.6,0,65.4,0c0,5.5,0,10.5,0,15.5
	c-0.8,0.1-1.3,0.1-1.8,0.1c-37.7,0-75.5,0-113.2,0c-7.4,0-10.8-4.8-8.4-11.9c4.8-14.7,9.6-29.3,14.7-43.9c1-2.9,2.7-5.8,4.8-7.9
	c13.8-14.1,27.8-28,41.8-41.9c0.9-0.9,1.7-1.9,3.2-3.5c-2.2,0-3.5,0-4.8,0c-10.7,0-21.4,0-32.1,0c-42.4,0-84.7,0-127.1,0
	c-7.9,0-10.5,2.6-10.5,10.6c0,11.4,0,22.9,0,34.3c0,1.2,0.1,2.3,0.2,3.5c6.1-2.5,8.2-2.1,12.8,2.5
	c54.8,54.8,109.7,109.7,164.5,164.6c1.9,1.9,3.7,2.7,6.3,2.7c32.9-0.1,65.8-0.1,98.6,0C356.9,315.9,366.9,314.8,376.3,320.1z
	 M37.5,196.7c59.1,59.1,118.4,118.4,177.4,177.4c10.7-10.7,21.8-21.8,32.7-32.6c-6.7-6.8-13.7-13.7-20.8-20.9
	c-5.2,5.3-10.6,10.9-15.5,16c-3.9-3.9-7.5-7.4-11.8-11.7c5.3-5.2,10.9-10.6,16.1-15.6c-6.6-6.6-13.1-13.1-20-20
	c-5.2,5.3-10.6,10.8-15.9,16.4c-3.8-3.8-7.3-7.4-11.1-11.2c5.4-5.3,11-10.8,16.2-15.9c-6.8-6.8-13.4-13.4-20.6-20.6
	c-5.2,5.2-10.6,10.7-15.8,15.9c-3.6-3.5-7.1-7-10.9-10.9c5.4-5.3,10.9-10.8,16-15.9c-6.7-6.7-13.3-13.3-20.3-20.3
	c-5.2,5.3-10.6,10.8-15.3,15.7c-3.7-3.6-7.3-7.2-11.4-11.2c5.2-5,10.6-10.4,15.6-15.3c-6.6-6.6-13.2-13.2-20.5-20.5
	c-5.1,5.3-10.5,10.8-15.5,16.1c-3.6-3.5-7.2-6.9-11.4-10.9c5.6-5.4,11.2-10.8,16.2-15.7c-7.1-7.1-14-14-20.7-20.7
	C59.3,175,48.3,186,37.5,196.7z M294.9,65.9c-28.2,28.2-56.7,56.7-84.9,84.9c6.5,6.6,13.4,13.6,19.9,20.2c28.4-28.4,56.9-57,85-85.1
	C308.2,79.3,301.3,72.3,294.9,65.9z M64.7,247.9c0,19.1,0,38.4,0,57.6c0,7.7,2.6,10.4,10.2,10.4c18.3,0,36.5,0,54.8,0
	c1,0,2.1-0.1,2.8-0.1C109.9,293.2,87.4,270.6,64.7,247.9z M327.1,74.6c5.3-5.3,10.7-10.3,15.8-15.7c3.2-3.3,3.1-7.1,0.1-10.5
	c-3.4-3.8-7-7.4-10.8-10.8c-2.6-2.4-6.3-3.3-9-0.8c-5.8,5.6-11.1,11.7-16.5,17.5C313.2,60.7,320,67.5,327.1,74.6z M345.4,362.7
	c4.5,0,8.8,0,13.2,0c1.6,0,3.2,0,4.7-0.2c7.1-1.1,12.8-7.5,13-14.6c0.2-7.8-4.9-15-12.2-15.8c-6.1-0.7-12.3-0.1-18.7-0.1
	C345.4,342,345.4,352.2,345.4,362.7z M200.9,165.8c-2.2,6.7-4.5,13.5-6.9,21c7.6-2.6,14.4-4.8,20.9-7
	C210.1,175,205.6,170.5,200.9,165.8z"/>
            <path className="st1" d="M64.7,247.9c22.7,22.7,45.3,45.3,67.8,67.8c-0.7,0-1.8,0.1-2.8,0.1c-18.3,0-36.5,0-54.8,0
	c-7.6,0-10.2-2.6-10.2-10.4C64.7,286.3,64.7,267.1,64.7,247.9z"/>
            <path className="st0" d="M314.2,206.6c0-5,0-9.9,0-15.1c5.1,0,10,0,15.2,0c0,5,0,9.9,0,15.1C324.4,206.6,319.4,206.6,314.2,206.6z" />
            <path className="st0" d="M360.6,206.7c-5.3,0-10.1,0-15.1,0c0-5.1,0-10,0-15.2c5,0,10,0,15.1,0C360.6,196.6,360.6,201.5,360.6,206.7z" />
        </svg>

    );
}

export default SvgHotelDashboard;
